export const isPaidOrder = (order) => {
	return order.payments.every(el => el.payed)
}

export const isFullyPaidOrder = (order) => {
	return order?.payments?.length > 0 && isPaidOrder(order)
}
